// block-unblock.component.ts
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'app-block-unblock',
  templateUrl: './block-unblock.component.html',
  imports: [CommonModule]
})
export class BlockUnblockComponent {
  @Input() isBlocking!: boolean
  @Input() recordId!: string // Add businessId input
  @Input() title!: string // Add businessId input
  @Input() desc!: string // Add businessId input
  @Output() confirm = new EventEmitter<{ id: string; status: boolean }>() // Emit the business ID and status
  @Output() cancel = new EventEmitter<void>()

  constructor(private modalService: NgbModal) {}

  onConfirm() {
    // this.confirm.emit({ id: this.Id, status: this.isBlocking })
    // this.modalService.dismissAll() // Pass the result back
    const result = { id: this.recordId, status: this.isBlocking, title: this.title }
    this.modalService.dismissAll(result) // This will pass the result back to the parent
  }

  onCancel() {
    this.cancel.emit()
    this.modalService.dismissAll() // Pass the result back
  }
}
